<template>
  <div
    v-if="canRevokeToken && model.status === TokenStatus.Active"
    class="w-10"
  >
    <loader :is-loading="isDeletingToken" />

    <div
      v-tooltip="$t('COMMON.REVOKE')"
      data-cy="revoke-button"
      class="cursor-pointer"
      @click="showRevokeModal = true"
    >
      <icon-base
        :icon="IconTrashCanOutline"
        class="text-gray-400 hover:text-red-500"
        @click="showRevokeModal = true"
      />
    </div>

    <confirm-modal
      v-if="showRevokeModal"
      :title="$t('EMPLOYEES.ACCESS_TOKENS.REVOKE_TITLE')"
      :description="$t('EMPLOYEES.ACCESS_TOKENS.REVOKE_DESCRIPTION')"
      :confirm-button="$t('COMMON.REVOKE')"
      :close="() => (showRevokeModal = false)"
      confirm-button-type="error"
      @confirm="removeToken"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { Ability, PermissionSubject } from "@/enums/auth";
import { usePermissions } from "@/hooks/auth";
import { useAccessTokenDeleteMutation } from "@/hooks/queries/accessTokens";
import { TokenStatus } from "@/schemas/accessTokens";

import IconTrashCanOutline from "@/components/icons/IconTrashCanOutline.vue";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import Loader from "@/components/ui/Loader.vue";

import type { AccessToken } from "@/schemas/accessTokens";

const props = defineProps<{ model: AccessToken }>();

const { canPerformActionReactive } = usePermissions();

const { mutate: deleteToken, isPending: isDeletingToken } =
  useAccessTokenDeleteMutation();

const canRevokeToken = canPerformActionReactive(
  PermissionSubject.accessToken,
  Ability.revoke,
  { accessToken: props.model.id }
);

const showRevokeModal = ref(false);

const removeToken = () => {
  deleteToken(props.model.id);
  showRevokeModal.value = false;
};
</script>
